import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveDropVoteSummaryProps {
  readonly drop: ExtendedDrop;
  readonly isWinner: boolean;
  readonly isVotingEnded: boolean;
  readonly canShowVote: boolean;
  readonly onVoteClick: () => void;
}
const PRIMARY_BUTTON_CLASSES = "tw-px-4 tw-py-2.5 tw-text-sm tw-font-semibold tw-flex tw-items-center tw-rounded-lg tw-bg-iron-200 tw-text-iron-950 tw-border-0 tw-ring-1 tw-ring-inset tw-ring-white hover:tw-bg-iron-300 hover:tw-ring-iron-300 tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer";
export const WaveDropVoteSummary = t0 => {
  const $ = _c(26);
  const {
    drop,
    isWinner,
    isVotingEnded,
    canShowVote,
    onVoteClick
  } = t0;
  const hasUserVoted = drop.context_profile_context?.rating !== undefined && drop.context_profile_context?.rating !== 0;
  const userVote = drop.context_profile_context?.rating ?? 0;
  const isUserVoteNegative = userVote < 0;
  const shouldShowUserVote = (isVotingEnded || isWinner) && hasUserVoted;
  let t1;
  if ($[0] !== drop.rating) {
    t1 = formatNumberWithCommas(drop.rating);
    $[0] = drop.rating;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="tw-text-sm sm:tw-text-base tw-font-semibold tw-text-white tw-tabular-nums">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop.id || $[5] !== drop.rating || $[6] !== drop.rating_prediction) {
    t3 = drop.rating !== drop.rating_prediction && <><FontAwesomeIcon icon={faArrowRight} className="tw-flex-shrink-0 tw-size-2.5 tw-text-iron-600" /><span className={`tw-text-sm sm:tw-text-base tw-font-semibold tw-tabular-nums tw-cursor-help ${drop.rating < drop.rating_prediction ? "tw-text-emerald-400" : "tw-text-rose-400"}`} data-tooltip-id={`drop-vote-progress-${drop.id}`}>{formatNumberWithCommas(drop.rating_prediction)}</span><Tooltip id={`drop-vote-progress-${drop.id}`} place="top" offset={8} opacity={1} style={TOOLTIP_STYLES}>Projected vote count at decision time</Tooltip></>;
    $[4] = drop.id;
    $[5] = drop.rating;
    $[6] = drop.rating_prediction;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="tw-text-sm sm:tw-text-base tw-text-iron-500 tw-font-normal tw-whitespace-nowrap">{t4} Total</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className="tw-px-4 tw-flex tw-flex-wrap tw-items-baseline tw-gap-1.5 tw-cursor-default">{t2}{t3}{t5}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== drop.wave.voting_credit_type || $[15] !== isUserVoteNegative || $[16] !== shouldShowUserVote || $[17] !== userVote) {
    t7 = shouldShowUserVote && <div className="tw-px-4 tw-flex tw-items-baseline tw-gap-1 tw-border-l tw-border-solid tw-border-white/5 tw-border-y-0 tw-border-r-0"><span className="tw-text-sm sm:tw-text-base tw-font-normal tw-text-iron-500">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm sm:tw-text-base tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}</span><span className="tw-text-iron-500 tw-text-sm sm:tw-text-base tw-font-normal">{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</span></div>;
    $[14] = drop.wave.voting_credit_type;
    $[15] = isUserVoteNegative;
    $[16] = shouldShowUserVote;
    $[17] = userVote;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== canShowVote || $[20] !== onVoteClick) {
    t8 = canShowVote && <button type="button" onClick={onVoteClick} className={PRIMARY_BUTTON_CLASSES}>Vote</button>;
    $[19] = canShowVote;
    $[20] = onVoteClick;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-2 sm:tw-gap-3 tw-p-1.5 tw-bg-iron-950 tw-border tw-border-solid tw-border-white/10 tw-rounded-xl tw-shadow-2xl tw-transition-transform hover:tw-scale-[1.01]">{t6}{t7}{t8}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};